/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChevronLargeUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAsklEQVR4nGNgGAWjgG7AxydSxDcg/AQIg9hUNdwjNFTULyD8ol9AxH8Q9vWPuOYVGipBFcN9fCJFEIaHX/ENiLgKZV+k2CcoLvcPvx4YGC0ZGBgj5ucfcZlin2AznAEKKLYE3XAvLAaQbQmy4YQ0gizxDQi/RLQlpBiOrIdoS3z9w0/CUghII06F2IIrIPwKNEj34rYgIOKgn3/EcXKSXyA4uCIO+vqHzyVV7ygYBcMdAACE0X42YArKbwAAAABJRU5ErkJggg==)
 */
export const ChevronLargeUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3.3 15.7a1 1 0 0 0 1.4 0L12 8.42l7.3 7.3a1 1 0 0 0 1.4-1.42l-8-8a1 1 0 0 0-1.4 0l-8 8a1 1 0 0 0 0 1.42Z"
        className={colorClass}
      />
    </svg>
  );
};
